export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const auth0Config = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
};

export const basePathConfig = {
  baseURL: process.env.REACT_APP_BASE_URl,
  socketURL: process.env.REACT_APP_SOCKET_URl,
};

// export const basePathConfig = {
//   baseURL: "http://127.0.0.1:4230",
//   //socketURL: "http://127.0.0.1:3123/account",
//   socketURL: "http://127.0.0.1:4230/account",
// };

// export const basePathConfig = {
//   baseURL: "https://liveagentservices.1spoc.ai:3123",
//   socketURL: "https://liveagentservices.1spoc.ai:3123/account",
// };
